export default __webpack_public_path__ + "book_details-ebook_pages.bb60a099.png";